export const updateProfileService = (request) => {
  const UPDATE_PROFILE_API_ENDPOINT = '/service/liquidlove/updateadmin';
  //const UPDATE_PROFILE_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/updateadmin';
  
  const parameters = {
    method: 'POST',
    headers: {      
      'Authorization': 'Bearer ' + request.admin.token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.admin.data)
  };

  return fetch(UPDATE_PROFILE_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const saveSecondaryDistrictsService = (request) => {
  const SAVE_SECONDARY_DISTRICTS_API_ENDPOINT = '/service/liquidlove/updateSecondaryDistricts';
  //const SAVE_SECONDARY_DISTRICTS_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/updateSecondaryDistricts';
  
  const parameters = {
    method: 'POST',
    headers: {      
      'Authorization': 'Bearer ' + request.payload.token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.payload)
  };

  return fetch(SAVE_SECONDARY_DISTRICTS_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const changePwdService = (request) => {
  const CHANGE_PWD_API_ENDPOINT = '/service/liquidlove/changepwd';
  //const CHANGE_PWD_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/changepwd';
  
  const parameters = {
    method: 'POST',
    headers: {      
      'Authorization': 'Bearer ' + request.admin.token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.admin.data)
  };

  return fetch(CHANGE_PWD_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const resetPwdService = (request) => {
  const RESET_PWD_API_ENDPOINT = '/service/liquidlove/resetpwd';
  //const RESET_PWD_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/resetpwd';
  
  const parameters = {
    method: 'POST',
    headers: {      
      'Authorization': 'Bearer ' + request.admin.token,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.admin.data)
  };

  return fetch(RESET_PWD_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const forgotPwdService = (request) => {
  const FORGOT_PWD_API_ENDPOINT = '/service/liquidlove/forgotpwd';
  //const FORGOT_PWD_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/forgotpwd';
  
  const parameters = {
    method: 'POST',
    headers: {      
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.admin)
  };

  return fetch(FORGOT_PWD_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const deregisterAdminService = (request) => {
  const DEREGISTER_ADMIN_API_ENDPOINT = '/service/liquidlove/admins';
  //const DEREGISTER_ADMIN_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/admins';
  
  const parameters = {
    method: 'DELETE',
    headers: {
      'Authorization': 'Bearer ' + request.payload.token,      
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.payload)
  };

  return fetch(DEREGISTER_ADMIN_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};

export const fetchAllAdminService = (request) => {
  const FETCH_ALL_ADMIN_API_ENDPOINT = '/service/liquidlove/admins';
  //const FETCH_ALL_ADMIN_API_ENDPOINT = 'http://localhost:4001/service/liquidlove/admins';
  
  const parameters = {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + request.payload.token,      
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(request.payload)
  };

  return fetch(FETCH_ALL_ADMIN_API_ENDPOINT, parameters)
    .then(response => {
      return response.json();
    })
    .then(json => {
      return json;
    });
};